module.exports = __webpack_public_path__ + "static/img/ic_community_c.b14e93e5.png";